import type { FaireProductEntity } from "../../entity_types/product";

export const p_d5x2aerrdh: FaireProductEntity = {
  token: "p_d5x2aerrdh",
  type: "product",
  name: "18K Gold Plated S.Steel Sparkling Zircon Inlaid Ring - FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl:
    "https://cdn.faire.com/fastly/9a77197dfd6d34d9edd2490c7432a62c44e8e5f68054bb4298e0010bcd3cdec7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e3d2d9f6cb87d93cb3d878a9d98618eae2d9951b23665623577cb036341b4921.jpeg",
    "https://cdn.faire.com/fastly/392ba573cfac87d31ed33c68918e14ee9e438b8d36718f141ddade224abc2a4e.jpeg",
    "https://cdn.faire.com/fastly/bbc0c27b18ab0736f5946d077583767755a55c072884b256e4f63f4e8575fc99.jpeg",
    "https://cdn.faire.com/fastly/322053258c90a6af58dc507acbf27e927dfc7d028ff9e9e97eab509e3cf241cd.jpeg",
    "https://cdn.faire.com/fastly/992f4d1b0c7940172661332b7a22d8f201fb7e921c3b14a27936bddc1da2c14f.jpeg",
  ],
  priceDollars: 6.89,
  description:
    "Type: Ring\nMaterial : Stainless steel ，Zircon，18K gold plated\nSize ： Please refer to Size chart of rings\nProcess: Vacuum electroplating and manual polishing,Non tarnish\nSurface : High Polish\n★Made of high quality stainless steel，Lead-free，Harmless to Human Body.\n★Perfect jewelry gifts",
  tags: [],
  msrpDollars: 17.21,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:41.400Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
